

































































import { Component, Mixins } from 'vue-property-decorator'
import AuthService from '@/services/auth-service'
import SnackbarService from '@/services/snackbar-service'

@Component({
  components: {},
})
export default class LoginView extends Mixins(AuthService, SnackbarService) {
  username = ''
  password = ''

  sendEmailButtonPressed = false
  emailForPasswordReset = ''
  forgotPasswordDialogIsOpen = false
  emailValid = true

  login() {
    if (this.username === '' || this.password === '') {
      return
    }
    this.$store.state.loading = true
    this.getLogin(this.username, this.password)
      .then((res: any) => {
        const token = res.data.access_token
        localStorage.setItem('accessToken', token)
        this.$store.state.token = token
        this.getUser().then(() => {
          this.getAccount(this.$store.state.user.account_id).then(
            (res: any) => {
              this.$store.state.account = res.data
              if (this.$store.state.account.farms.length > 0) {
                this.$store.state.selectedFarmId = this.$store.state.account.farms[0].id
              }
              this.$store.state.loading = false
            }
          )
        })
        this.$router.push(this.$store.state.redirectToFromGuard)
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          this.notify({ text: `Wrong username or password` })
        } else if (error.response.status === 403) {
          this.notify({
            text: `Please open your email account and click on the registration link`,
            type: 'warning',
            timeout: 10000,
          })
        } else if (error.response.status === 423) {
          this.notify({
            text: `Your account is deactivated`,
            type: 'warning',
            timeout: 10000,
          })
        } else {
          this.notify({ text: `Error trying to login ${error}` })
        }
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  sendResetPasswordEmail() {
    if (this.emailForPasswordReset === '') {
      return
    }
    this.sendEmailButtonPressed = true
    this.validateEmail()
    if (!this.emailValid) {
      return
    }
    this.$store.state.loading = true
    this.sendPasswordResetEmail(this.emailForPasswordReset)
      .then((res: any) => {
        this.notify({
          text: `Email sended successfully. Please check your email account`,
          type: 'success',
        })
        this.forgotPasswordDialogIsOpen = false
      })
      .catch((error: any) => {
        this.notify({ text: `Error trying to login ${error}` })
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  validateEmail() {
    if (!this.sendEmailButtonPressed) {
      this.emailValid = true
    } else {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.emailValid = re.test(
        String(this.emailForPasswordReset).toLowerCase()
      )
    }
  }

  get getEmailValidErrMessage() {
    return this.emailValid ? null : 'This is not a valid email address'
  }
}
